import PropTypes from "prop-types";
import { memo } from "react";
import DepartureCity from "./DepartureCity.jsx";
import "./DepartureCityList.scss";
import { FormattedMessage } from "react-intl";

const DepartureCityList = ({
	departureCities = [],
	onDepartureCityChange,
	productInfo,
	showCTA,
}) => {
	let departureCitiesNode = departureCities.map(departureCity => {
		return (
			<div key={departureCity.code} className="departure-city__item">
				<DepartureCity
					productInfo={productInfo}
					amountSuffix={
						<FormattedMessage id="general.amount.per.person.suffix.label.short" />
					}
					departureCity={departureCity}
					showCTA={showCTA}
					onChange={onDepartureCityChange}
					data-testid={`search-engine-departure-city-${departureCity.code}`}
				/>
			</div>
		);
	});

	return <div className="departure-city__list">{departureCitiesNode}</div>;
};

DepartureCityList.propTypes = {
	productInfo: PropTypes.object,
	departureCities: PropTypes.array,
	onDepartureCityChange: PropTypes.func,
	showCTA: PropTypes.bool,
};

export default memo(DepartureCityList);
